import { useState } from "react";

type RollerConveyorControlsProps = {
  disabled?: boolean;
  initialEndInset: number;
  initialXInset: number;
  initialYOffset: number;
  onEndInsetChange: (sideRailEndInset: number) => void;
  onXInsetChange: (sideRailXInset: number) => void;
  onYOffsetChange: (sideRailYOffset: number) => void;
};

export function RollerConveyorControls({
  disabled = false,
  initialEndInset,
  initialXInset,
  initialYOffset,
  onEndInsetChange,
  onXInsetChange,
  onYOffsetChange
}: RollerConveyorControlsProps) {
  const [endInsetDraft, setEndInsetDraft] = useState(String(initialEndInset));
  const [xInsetDraft, setXInsetDraft] = useState(String(initialXInset));
  const [yOffsetDraft, setYOffsetDraft] = useState(String(initialYOffset));

  return (
    <div className="roller-conveyor-controls">
      <span className="roller-conveyor-controls-title">辊道输送机</span>
      <label className="roller-conveyor-controls-field">
        <span>侧杆 Y 偏移</span>
        <span className="roller-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setYOffsetDraft(nextDraft);
              if (Number.isFinite(nextValue)) {
                onYOffsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={yOffsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="roller-conveyor-controls-field">
        <span>侧杆 X 向内偏移</span>
        <span className="roller-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setXInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onXInsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={xInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
      <label className="roller-conveyor-controls-field">
        <span>侧杆最终向内缩进</span>
        <span className="roller-conveyor-controls-input-wrap">
          <input
            disabled={disabled}
            inputMode="decimal"
            min="0"
            onChange={(event) => {
              const nextDraft = event.target.value;
              const nextValue = Number(nextDraft);
              setEndInsetDraft(nextDraft);
              if (Number.isFinite(nextValue) && nextValue >= 0) {
                onEndInsetChange(nextValue);
              }
            }}
            step="0.01"
            type="number"
            value={endInsetDraft}
          />
          <span>m</span>
        </span>
      </label>
    </div>
  );
}
